class IdeaFormStorage
{
	titleStorageKey;
	descriptionStorageKey;
	urlStorageKey;

	formSelector;
	nameSelector;
	descriptionSelector;
	currentUrl;

	updateStorageInterval;

	documentReady = false;
	froalaReady = false;
	initialized = false;

	constructor(storagePrefix)
	{
		this.titleStorageKey = `${storagePrefix}.ideaTitle`;
		this.descriptionStorageKey = `${storagePrefix}.ideaDescription`;
		this.urlStorageKey = `${storagePrefix}.url`;
	}

	init(formSelector, nameSelector, descriptionSelector)
	{
		this.formSelector = formSelector;
		this.nameSelector = `${formSelector} ${nameSelector}`;
		this.descriptionSelector = `${formSelector} ${descriptionSelector}`;
		this.currentUrl = window.location.pathname;

		const thisObj = this;

		$(function ()
		{
			thisObj._onDocumentReady();
		});
	}

	getUrl()
	{
		return localStorage.getItem(this.urlStorageKey);
	}

	clear()
	{
		if (this.updateStorageInterval != null)
			clearInterval(this.updateStorageInterval);

		localStorage.removeItem(this.titleStorageKey);
		localStorage.removeItem(this.descriptionStorageKey);
		localStorage.removeItem(this.urlStorageKey);
	}

	_onDocumentReady()
	{
		this.documentReady = true;
		this._checkReady();
	}

	onFroalaReady()
	{
		this.froalaReady = true;
		this._checkReady();
	}

	_checkReady()
	{
		if (!this.documentReady || !this.froalaReady)
			return;
		
		if (this.initialized)
			return;
		
		this.initialized = true;

		this._restoreFromStorage();
		this.updateStorageInterval = setInterval(this._updateLocalStorageForIdea.bind(this), 1000);

		$(`${this.formSelector} .cancel-button`).on('click', this.clear.bind(this));

		const thisObj = this;
		$(this.formSelector).on('submit', function (e)
		{ 
			e.preventDefault();
			thisObj.onSubmit();
			this.submit();
		});
	}

	onSubmit()
	{
		this.clear();
	}

	_restoreFromStorage()
	{
		const name = localStorage.getItem(this.titleStorageKey);
		if (name != null && name.length > 0)
			$(this.nameSelector).val(name).trigger('input');
		const description = localStorage.getItem(this.descriptionStorageKey);
		if (description != null && description.length > 0) {
			$(this.descriptionSelector).prop("data-froala.editor").html.set(localStorage.getItem(this.descriptionStorageKey));
		}
	}

	_updateLocalStorageForIdea()
	{

		var title = $(this.nameSelector).val();
		var description = $(this.descriptionSelector).prop("data-froala.editor").html.get();

		localStorage.setItem(this.titleStorageKey, title);
		localStorage.setItem(this.descriptionStorageKey, description);
		localStorage.setItem(this.urlStorageKey, this.currentUrl);
	}
}